import { observer } from 'mobx-react-lite'
import { useEffect, useRef } from 'react'
import { QCM } from 'react-sdk/activities/QCM'
import classes from './Qcm.module.css'
import QcmChoices from './QcmChoices'
import QrlInput from './QrlInput'

/**
 *
 * @param {object} props
 * @param {QCM} props.instance
 * @returns
 */
const Qcm = ({instance, onReadyToValidate}) => {

  const ctnrRef = useRef(null)

  useEffect(() => {
    onReadyToValidate(instance.selectedChoices.length > 0)

  }, [instance.selectedChoices]);

  return (
    <div className={classes.QCM} ref={ctnrRef}>
      <QcmChoices qcm={instance}  />
    </div>
  )
}


export default observer(Qcm)